import Vue from 'vue'
import { USER_INFO, ENHANCE_PRE,SYS_TYPE } from "@/store/mutation-types"
import {isUndefinedAndNull} from '@/utils/validate'
const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => {state.user.avatar = Vue.ls.get(USER_INFO).avatar; return state.user.avatar},
  username: state => state.user.username,
  nickname: state => {state.user.realname = Vue.ls.get(USER_INFO).realname; return state.user.realname},
  welcome: state => state.user.welcome,
  permissionList: state => state.user.permissionList,
  areaList: state => state.user.areaList,
  userInfo: state => {state.user.info = Vue.ls.get(USER_INFO); return state.user.info},
  addRouters: state => state.permission.addRouters,
  onlAuthFields: state => {return state.online.authFields },
  enhanceJs:(state) => (code) => {
    state.enhance.enhanceJs[code] = Vue.ls.get(ENHANCE_PRE+code);
    return state.enhance.enhanceJs[code]
  },
  sysType:state => {state.user.sysType = Vue.ls.get(SYS_TYPE); return state.user.sysType},
  language: state => state.app.language,
  
  menusData: state => {
    //state.user.sysType = Vue.ls.get(SYS_TYPE);
    console.log(Vue.ls.get(SYS_TYPE))
    if(isUndefinedAndNull(state.user.sysType)) {
      state.user.sysType = Vue.ls.get(SYS_TYPE);
    }
    let system = {1: 'waterAnalysis',2: 'waterMonitoring',3: 'maintenanceDevice',4: 'meterManagement',5: 'meterReadingManagement',6: 'isystem',7: 'engineeringInstallation',8: 'workOrderManagement',9: 'inspectionManagement',10: 'OAoffice',11:'hotline',12:'DMAPartitionMetering',13:'notifications'}
    let index = state.user.permissionList.findIndex((item) => {
      return item.name.indexOf(system[state.user.sysType])>=0
    })
    console.log("index:"+index)
    if(index<0) {
      return []
    }
    if(state.user.sysType == 2) {
      return state.user.permissionList[index].children
    }else{
      return state.user.permissionList[index].children
    }
  }
}

export default getters
